import React, { Fragment, useState } from 'react';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import EditOrLock from './common/EditOrLock';

import { showModal } from '../../../actions/modal';

import { WAREHOUSE_TYPE_TRANSLATE } from '../../../config';
import Checkbox from '../../common/Checkbox';
import Lock from '../../common/Lock';
import Radios from '../../common/Radios';
import { freeDeliveryRegionData } from '../../Settings/CheckoutBlock';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  padding-left: 0;
  padding-right: 0;
  box-shadow: none;
  border: 1px solid #ebebeb;
  min-height: 140px !important;

  .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
    background: #d2d3d6;
    border-color: #d2d3d6;
  }

  > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 10px;

    &:last-child {
      padding-bottom: 0;
    }
  }

  .help-tooltip-wrapper {
    margin-left: 15px;
    color: #6e768e;
    line-height: 16px;
    font-weight: normal;

    i {
      margin-left: 2px;
    }
  }

  .card-title {
    display: flex;
    align-items: center;
    padding-top: 4px;
    padding-bottom: 24px;
    justify-content: space-between;
    min-height: 47px;

    .header-title {
      font-size: 16px;
      margin-bottom: 0px;
    }

    .change-link {
      margin-top: -3px;
    }
  }

  .border-top {
    padding-top: 24px;
    padding-bottom: 14px;
  }

  .badge {
    background: black;
    color: white;
    border-radius: 4px;
    padding: 4px 8px;
    font-weight: 500;
    font-size: 11px;
    line-height: 11px;
  }

  .right {
    display: flex;
    align-items: center;
  }

  .radios-group {
    label {
      cursor: pointer;
    }

    > div {
      margin-bottom: 4px;
    }
  }

  .pallet-number {
    color: #f245d6;
    font-weight: 700;
  }

  .box-number {
    color: #e292fe;
    font-weight: 700;
  }
`;

export const shippingOptionsData = [
  {
    label: 'Отгрузка микскоробами',
    value: 'MIX_PACKINGS',
  },
  {
    label: 'Отгрузка монокоробами',
    value: 'MONO_PACKINGS',
  },
  {
    label: 'Отгрузка монопаллетами',
    value: 'MONO_PALLETS',
  },
  {
    label: 'Отгрузка микспаллетами',
    value: 'MIX_PALLETS',
  },
];

const ShippingOptiBlock = (props) => {
  const { currentOrder, handleEditOrder } = props;

  const { t } = useAutoTranslation();

  const isMonoPack = currentOrder?.warehouseShippingOptions?.packingType === 'MONO_PACKINGS';
  const isMonoPallet = currentOrder?.warehouseShippingOptions?.packingType === 'MONO_PALLETS';
  const adminMode = localStorage.getItem('adminPanel');

  const handleChangeShippingOptions = (e, key) => {
    handleEditOrder({
      ...currentOrder,
      warehouseShippingOptions: {
        [key]: e,
      },
    });
  };

  const currentPermission = currentOrder.permissionList?.fieldPermissions?.find(
    (f) => f.type === 'WAREHOUSE_EDITABLE',
  );
  const editable = currentPermission ? currentPermission.value : true;

  const calculatePalletsFromArr = (arr) => {
    if (!arr) {
      return 0;
    }

    return arr.reduce(function (acc, curr) {
      return curr.type === 'PALLET' ? acc + 1 : acc;
    }, 0);
  };

  const calculatePalletsFromBox = (arr) => {
    if (!arr) {
      return 0;
    }

    const places = arr
      .map((item) => (item.places !== undefined ? item.places : null))
      .filter((n) => n)
      .flat(1);
    const newArr = [...arr, ...places];

    return newArr.reduce(function (acc, curr) {
      return curr.type === 'BOX' ? acc + 1 : acc;
    }, 0);
  };

  const currPallets = calculatePalletsFromArr(currentOrder.estimatedPlacesFromWms);
  const currBoxes = calculatePalletsFromBox(currentOrder.estimatedPlacesFromWms);

  return (
    <Wrapper className={`card-box`}>
      <div style={{ display: 'flex' }} className="card-title">
        <div>
          <h4 className="header-title">{t('Параметры отгрузки')}</h4>
        </div>
        <div className="right">
          {isMonoPack ? <div className="badge">{t('Монокороба')}</div> : null}
          {isMonoPallet ? <div className="badge">{t('Монопаллеты')}</div> : null}
          {!editable ? <Lock reason={currentPermission.reason} /> : null}
        </div>
      </div>
      <div className="border-top">
        <div className="form-group radios-group">
          <Radios
            data={shippingOptionsData}
            id="shippingOptionsData"
            name="shippingOptionsData"
            currentValue={
              currentOrder?.warehouseShippingOptions?.packingType ?? shippingOptionsData[0].value
            }
            onChange={(e) => handleChangeShippingOptions(e, 'packingType')}
            disabled={!editable}
          />
        </div>
        {adminMode === 'true' && (
          <>
            <p className="pallet-number">
              {t('Ориентировочное количество паллет')}: {currPallets}{' '}
            </p>
            <p className="box-number">
              {t('Ориентировочное количество коробов')}: {currBoxes}{' '}
            </p>
          </>
        )}
      </div>
    </Wrapper>
  );
};

export default ShippingOptiBlock;
